import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=064f3f1c&"
import script from "./Input.vue?vue&type=script&lang=ts&"
export * from "./Input.vue?vue&type=script&lang=ts&"
import style0 from "./Input.vue?vue&type=style&index=0&id=064f3f1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports